export default "__VITE_ASSET__CUdTIa0Y__"